import { tokens } from '@welbe/web-design-system';

const getProgressColor = (porcent: number) => {
	if (porcent === 100) {
		return tokens.color_primary;
	}
	if (porcent >= 80) {
		return tokens.color_secondary;
	}

	return tokens.color_gray_dark;
};

export default getProgressColor;
